module.exports = __webpack_public_path__ + "img/order.015d330b.svg";